// Single source of truth for the Support Panel navigation.
//
// Consumed by SupportPanelLayout.vue (desktop sidebar + mobile drawer top bar
// title) and SupportPanel/Dashboard.vue (the tool tile grid). Adding a tool is a
// one-line change here.
//
// `visibility` mirrors the access checks already enforced in the layout/controller:
//   - 'all'   → every user with support-panel access
//   - 'admin' → the operational admin account (email === 'admin@admin.com')
//   - 'owner' → the owner account (id === 1)
// `description` powers the dashboard tile subtitle. `danger` flags sensitive tools.
export const navGroups = [
    {
        section: 'General',
        visibility: 'all',
        items: [
            { label: 'Dashboard', routeName: 'support-panel.dashboard', iconName: 'home', description: 'Overview and quick access to your tools' },
            { label: 'User Search', routeName: 'support-panel.search', iconName: 'magnifying-glass', description: 'Find a user by email, ID, or order' },
            { label: 'Phone Lookup', routeName: 'support-panel.phone-lookup', iconName: 'device-phone-mobile', description: 'Look up a number and its activity' },
            { label: 'Rental Recovery', routeName: 'support-panel.rental-recovery', iconName: 'lifebuoy', description: 'Reinstate a lapsed rental or check recovery eligibility' },
            { label: 'Order Overview', routeName: 'support-panel.orders', iconName: 'queue-list', description: 'Filter orders by service to see if a service is failing for everyone' },
            { label: 'Deposits', routeName: 'support-panel.deposits', iconName: 'banknotes', description: 'Every deposit, searchable by transaction id, hash, address or email' },
            { label: 'OTP Blocks', routeName: 'support-panel.otp-blocks', iconName: 'pause-circle', description: 'Temporarily pause a user\'s one-time ordering, with a message. Rentals keep running' },
        ],
    },
    {
        section: 'Operations',
        visibility: 'admin',
        items: [
            { label: 'Hire Tool', routeName: 'support-panel.hire-tool', iconName: 'briefcase', description: 'Provision and assign rental numbers' },
            { label: 'Servers', routeName: 'support-panel.servers', iconName: 'cpu-chip', description: 'Devices and their SIM slots: current and past numbers, online status, rentals' },
            { label: 'Rental Extender', routeName: 'support-panel.rental-extender', iconName: 'clock', description: 'Extend an active rental period' },
            { label: 'Replacement Tool', routeName: 'support-panel.replacement-tool', iconName: 'arrow-path', description: 'Issue a replacement number' },
            { label: 'Phone Availability', routeName: 'support-panel.phone-availability-page', iconName: 'signal', description: 'Country supply health and per-service stock' },
            { label: 'Poland Numbers', routeName: 'support-panel.xmobility-numbers', iconName: 'device-phone-mobile', description: 'Upload X-Mobility (Poland) numbers CSV and manage stock' },
            { label: 'Server Monitor', routeName: 'support-panel.module-checker', iconName: 'server-stack', description: 'Module and provider health checks' },
        ],
    },
    {
        section: 'Finance',
        visibility: 'admin',
        items: [
            { label: 'Revenue', routeName: 'support-panel.revenue-overview', iconName: 'currency-dollar', description: 'Revenue overview and trends' },
            { label: 'Custom Pricing', routeName: 'support-panel.custom-pricing', iconName: 'currency-dollar', description: 'Per-user price overrides for one-time numbers' },
            { label: 'Financials', routeName: 'support-panel.financials', iconName: 'banknotes', description: 'Detailed financial breakdowns' },
            { label: 'Crypto Export', routeName: 'support-panel.crypto-export', iconName: 'document-text', description: 'Quarterly crypto deposits per country, as CSV or Excel' },
            { label: 'Statistics', routeName: 'support-panel.statistics', iconName: 'chart-bar', description: 'Operational metrics and charts' },
        ],
    },
    {
        section: 'Risk & Disputes',
        visibility: 'admin',
        items: [
            { label: 'Fraud Review', routeName: 'support-panel.fraud-review', iconName: 'shield-exclamation', description: 'Review flagged fraud cases' },
            { label: 'Dispute Scanner', routeName: 'support-panel.dispute-scanner', iconName: 'flag', description: 'Scan and triage chargebacks' },
        ],
    },
    {
        section: 'Growth',
        visibility: 'admin',
        items: [
            { label: 'Campaigns', routeName: 'support-panel.campaign-manager', iconName: 'megaphone', description: 'Manage promo and marketing campaigns' },
            // ONE entry, not one per campaign: the list of forums is unbounded, the screen
            // switches campaign with ?campaign=<slug>, and useSupportNav strips the query
            // before comparing paths — so this stays highlighted for every campaign.
            { label: 'Forum Promos', routeName: 'support-panel.bhw-claims', iconName: 'megaphone', description: 'Forum €3 claims: audit, revoke, kill switch' },
        ],
    },
    {
        section: 'Compliance',
        visibility: 'owner',
        items: [
            { label: 'LE Export', routeName: 'support-panel.law-enforcement-export', iconName: 'document-text', danger: true, description: 'Generate law-enforcement data exports' },
        ],
    },
];
